/* Customize page: switches the inline Kickflip customizer between colors/pieces. */

/* Kickflip's script normally arrives through its app embed (Online Store → Themes → Customize →
   App embeds → Kickflip). If the embed is off for this theme, load the same script directly so the
   customizer still appears. */
(function () {
  if (window.customElements && customElements.get('kickflip-customizer-iframe')) return;
  setTimeout(function () {
    if (customElements.get('kickflip-customizer-iframe') || document.querySelector('script[data-kf-fallback]')) return;
    var stage = document.getElementById('kf-stage');
    var src = stage && stage.getAttribute('data-script');
    if (!src) return;
    var s = document.createElement('script');
    s.src = src; s.defer = true; s.setAttribute('data-kf-fallback', '');
    document.head.appendChild(s);
  }, 600);
})();
(function () {
  var stage = document.getElementById('kf-stage');
  var list = document.getElementById('kf-colors');
  var label = document.getElementById('kf-selected');
  if (!stage || !list) return;
  var buttons = Array.prototype.slice.call(list.querySelectorAll('button[data-color]'));
  function shortTitle(t) { return t.split(',')[0].split('.')[0]; }
  function select(btn, push) {
    if (!btn || btn.getAttribute('aria-pressed') === 'true' && stage.firstElementChild) return;
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    // On phones the colors are one swipe row: keep the chosen one in view.
    var row = btn.parentElement;
    if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, btn.offsetLeft - row.offsetLeft - 60), behavior: 'smooth' });
    // Kickflip's element reads its attributes in its constructor, so it has to be parsed with
    // them already in place (createElement + setAttribute would render the "not customizable" box).
    var attrs = {
      borderRadius: '0px', brand: stage.dataset.brand, startingPointId: btn.dataset.startingPoint,
      onlineStoreId: stage.dataset.store, shopifyProductId: btn.dataset.productId,
      shopifyProductHandle: btn.dataset.handle, shopifyProductTitle: btn.dataset.title,
      shopifyVariantId: btn.dataset.variantId, countryIsoCode: stage.dataset.country,
      isCustomizable: 'true', priceAdjustmentValue: '', applyRounding: 'true'
    };
    var esc = function (v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
    stage.innerHTML = '<kickflip-customizer-iframe ' + Object.keys(attrs).map(function (k) {
      return k + '="' + esc(attrs[k]) + '"';
    }).join(' ') + '></kickflip-customizer-iframe>';
    if (label) {
      label.innerHTML = '';
      var strong = document.createElement('strong');
      strong.textContent = shortTitle(btn.dataset.title);
      label.appendChild(strong);
      label.appendChild(document.createTextNode(' · from ' + btn.dataset.price));
    }
    if (push) {
      var url = new URL(window.location.href);
      url.searchParams.set('piece', btn.dataset.family);
      url.searchParams.set('color', btn.dataset.color);
      history.replaceState(null, '', url);
    }
  }
  var famList = document.getElementById('kf-families');
  var famName = document.getElementById('kf-family-name');
  function showFamily(key, push) {
    if (!famList) return;
    Array.prototype.forEach.call(famList.querySelectorAll('button'), function (b) {
      b.setAttribute('aria-pressed', b.dataset.family === key ? 'true' : 'false');
    });
    var first = null;
    buttons.forEach(function (b) {
      var on = b.dataset.family === key;
      b.hidden = !on;
      if (on && !first) first = b;
    });
    if (first) { if (famName) famName.textContent = first.dataset.familyName; buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); select(first, push); }
  }
  if (famList) famList.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-family]');
    if (b) showFamily(b.dataset.family, true);
  });
  list.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-color]');
    if (btn) select(btn, true);
  });
  var params = new URLSearchParams(window.location.search);
  var byProduct = params.get('product') && buttons.filter(function (b) { return b.dataset.handle === params.get('product'); })[0];
  if (byProduct) {
    if (famList) showFamily(byProduct.dataset.family, false);
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    select(byProduct, false);
  } else if (params.get('piece')) showFamily(params.get('piece'), false);
  var wanted = !byProduct && params.get('color');
  if (wanted) {
    var match = buttons.filter(function (b) { return !b.hidden && b.dataset.color === wanted.toLowerCase().replace(/\s+/g, '-'); })[0];
    if (match && match.getAttribute('aria-pressed') !== 'true') select(match, false);
  }
})();
